import { render, staticRenderFns } from "./ReplacementWeek.vue?vue&type=template&id=76bac871&"
import script from "./ReplacementWeek.vue?vue&type=script&lang=js&"
export * from "./ReplacementWeek.vue?vue&type=script&lang=js&"
import style0 from "./ReplacementWeek.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports